import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'


const _hoisted_1 = { class: "px-5 pt-3 mb-5 page-fill" }
const _hoisted_2 = { class: "items-center justify-between flex" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_6 = { class: "mt-5 table-section" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title flex items-center" }, [
        _createElementVNode("h1", null, "Compliance Review")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btnprimary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addBtnCompliance()))
        }, "Add"),
        _createElementVNode("button", {
          class: _normalizeClass(["flex", _ctx.tableRow.length == 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton']),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
        }, [
          (_ctx.tableRow.length == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5)),
          _cache[2] || (_cache[2] = _createTextVNode(" Filters "))
        ], 2)
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mt-3" }, [
      _createElementVNode("p", { class: "headerText" }, " This page enables you to manage and perform compliance reviews across the organization. Plan, assign, and track review activities to ensure that security controls are effectively implemented and aligned with internal policies and external compliance requirements. ")
    ], -1)),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_tableData, {
        class: "flex-1 min-h-0",
        tableRowData: _ctx.tableRow,
        headersData: _ctx.headers,
        tableRouteArr: _ctx.optionsValue,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "tableRouteArr", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}